import { DevToolsPanel } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsPanel';
import { DevToolsToggle } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsToggle';
import type { SoftphoneDevToolsProps } from 'Modules/softphone/components/SoftphoneDevTools/index.types';
import { useDevToolsStore } from 'Modules/softphone/components/SoftphoneDevTools/store';
import { useSoftphoneDiagnosticsAccess } from 'Modules/softphone/hooks/useSoftphoneDiagnosticsAccess';
import React, { useEffect } from 'react';

export { DevToolsToggle } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsToggle';
export { useDevToolsStore } from 'Modules/softphone/components/SoftphoneDevTools/store';
export { MAX_DEBUG_HISTORY_CALLS, SOFTPHONE_DEBUG_HISTORY_KEY } from 'Modules/softphone/components/SoftphoneDevTools/constants';
export { loadDebugHistory, saveDebugHistory, clearDebugHistory } from 'Modules/softphone/components/SoftphoneDevTools/storage';

/**
 * SoftphoneDevTools - Development-only DevTools for Softphone debugging
 *
 * Like React Query DevTools, but for the softphone:
 */
export const SoftphoneDevTools: React.FC<SoftphoneDevToolsProps> = ({
  children,
}) => {
  const { hasAccess } = useSoftphoneDiagnosticsAccess();

  // Losing access has to reset the open state, not just hide the panel.
  // Otherwise switching the setting off and on again would pop the panel
  // straight back open, which reads as the toggle not having worked.
  useEffect(() => {
    if (!hasAccess) {
      useDevToolsStore.getState().close();
    }
  }, [hasAccess]);

  // Access is the "Enable softphone diagnostics panel" setting (CUU2-3511):
  // feature flag + new softphone + the per-user toggle. Revoking it while the
  // panel is open removes the panel on the next render, with no reload.
  if (!hasAccess) {
    return <>{children}</>;
  }

  return (
    <>
      {children}
      <DevToolsToggle />
      <DevToolsPanel />
    </>
  );
};
